import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../../contexts/AuthContext';

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    // If user is already logged out locally, redirect to home
    // This handles the case when Cognito redirects back after global logout
    if (!isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    // If user is still authenticated, perform logout
    // The logout function in AuthContext will:
    // 1. Clear local auth state
    // 2. Redirect to Cognito logout URL for global sign-out
    // 3. Cognito will redirect back to this /logout route
    logout();
  }, [logout, isAuthenticated, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '50vh' 
    }}>
      <Spin size="large" tip="Signing out..." />
    </div>
  );
};

export default Logout;
